import { render, staticRenderFns } from "./MedDamageTypes.vue?vue&type=template&id=bc0233d8&scoped=true"
import script from "./MedDamageTypes.vue?vue&type=script&lang=js"
export * from "./MedDamageTypes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc0233d8",
  null
  
)

export default component.exports